'use client';

import { IHeaderProps } from '@/globals/Header/type';
import { useEffect, useState } from 'react';
import HamburgerMenu from '@/icons/HamburgerMenu';
import { X } from 'lucide-react';
import { cn } from '@/utilities/cn';
import { Header } from '@/payload-types';
import MHeaderLinkItem from '@/globals/Header/components/mobile/MHeaderLinkItem';
import { usePathname, useSearchParams } from 'next/navigation';
import HeaderLanguageSelector from '@/globals/Header/components/HeaderLanguageSelector';

export default function MHeaderHamburgerMenu(props: IHeaderProps) {
  const { header } = props;
  const { firstRow, secondRow } = header || {};
  const { language } = firstRow || {};

  const navLinks = [...(secondRow?.navItems || []), ...(firstRow?.navItems || [])] as Exclude<
    Header['secondRow'],
    undefined
  >['navItems'];

  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);

  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    setIsOpen(false);
  }, [pathname, searchParams]);

  return (
    <div className="flex w-8">
      <button
        onClick={toggleOpen}
        className="relative"
        aria-label='Open menu'
      >
        <HamburgerMenu
          className={cn(
            'transition-all duration-500 text-secondary opacity-100 translate-y-0',
            isOpen && 'opacity-0 pointer-events-none -translate-y-full h-0',
          )}
        />
        <X
          height={32}
          className={cn(
            'm-auto transition-all duration-500 text-secondary absolute inset-0 opacity-0 pointer-events-none translate-y-full',
            isOpen && 'opacity-100 pointer-events-auto translate-y-0',
            !isOpen && 'h-0'
          )}
        />
      </button>
      <div
        className={cn(
          'z-30 fixed left-0 right-0 bottom-0 top-14 bg-neutral-100 transition-all duration-500 overflow-hidden max-h-0',
          '[html.translated-ltr_&]:top-24',
          isOpen && 'hamburger--open overflow-auto max-h-full',
        )}
      >
        <ul className="flex flex-col gap-5 p-4">
          {navLinks?.map((item, index) => <MHeaderLinkItem item={item} key={index} />)}
        </ul>
        <HeaderLanguageSelector language={language} />
      </div>
    </div>
  );
}
